import { motion } from "framer-motion";
import Nav from "../components/Nav";
import Footer from "../components/Footer";

const CONTENT = {
  termos: {
    title: "Termos de Contratação",
    sections: [
      ["1. Objeto", "Estes termos regem a contratação dos serviços de marketing digital (tráfego pago, social media, reels, design e consultoria) prestados pela Triad Marketing."],
      ["2. Planos e Cobrança", "Os planos são mensais e renovados automaticamente até solicitação de cancelamento. O valor do investimento em anúncios pagos é de responsabilidade do contratante e cobrado à parte, quando aplicável."],
      ["3. Pagamento", "Os pagamentos são processados de forma segura pela InfinitePay via PIX ou cartão. A Triad Marketing não armazena dados de cartão."],
      ["4. Início do Serviço", "Após a confirmação do pagamento, nossa equipe entra em contato para alinhamento, coleta de acessos e início do planejamento."],
      ["5. Cancelamento", "O contrato não possui fidelidade. O cancelamento pode ser solicitado a qualquer momento e passa a valer no ciclo seguinte."],
    ],
  },
  privacidade: {
    title: "Política de Privacidade",
    sections: [
      ["1. Dados Coletados", "Coletamos nome, e-mail, telefone e dados da empresa fornecidos no momento da contratação, além de informações necessárias à prestação do serviço."],
      ["2. Uso dos Dados", "Os dados são utilizados exclusivamente para prestação do serviço, comunicação e emissão de documentos fiscais, conforme a LGPD."],
      ["3. Pagamentos", "Dados de pagamento são processados diretamente pela InfinitePay. Não temos acesso nem armazenamos números de cartão."],
      ["4. Compartilhamento", "Não vendemos nem compartilhamos seus dados com terceiros, exceto quando exigido por lei ou para operacionalizar o pagamento."],
      ["5. Seus Direitos", "Você pode solicitar acesso, correção ou exclusão dos seus dados a qualquer momento pelo nosso WhatsApp."],
    ],
  },
  cancelamento: {
    title: "Política de Cancelamento",
    sections: [
      ["1. Sem Fidelidade", "Todos os planos são mensais e sem fidelidade contratual."],
      ["2. Como Cancelar", "Solicite o cancelamento pelo WhatsApp (11) 98966-6465. A solicitação é confirmada em até 2 dias úteis."],
      ["3. Vigência", "O cancelamento passa a valer no ciclo de cobrança seguinte. O ciclo já pago é integralmente executado."],
      ["4. Reembolso", "Serviços já iniciados no ciclo vigente não são reembolsáveis, conforme natureza do trabalho de marketing."],
    ],
  },
};

export default function Legal({ page }) {
  const data = CONTENT[page] || CONTENT.termos;
  return (
    <main data-testid={`legal-${page}`} className="min-h-screen bg-ink-950 text-white/90">
      <Nav />
      <section
        className="pt-40 pb-24"
        style={{ background: "radial-gradient(ellipse 80% 50% at 50% 0%, rgba(10,77,255,0.2), transparent 60%), #050505" }}
      >
        <div className="mx-auto max-w-3xl px-6 md:px-12">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="font-serif font-bold text-4xl md:text-5xl text-white tracking-tight mb-12"
          >
            {data.title}
          </motion.h1>
          <div className="space-y-8">
            {data.sections.map(([h, body], i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
              >
                <h2 className="font-serif text-xl text-white font-semibold mb-2">{h}</h2>
                <p className="text-white/60 leading-relaxed text-sm">{body}</p>
              </motion.div>
            ))}
          </div>
          <p className="mt-16 text-white/40 text-xs">
            Última atualização: {new Date().toLocaleDateString("pt-BR")} · Triad Marketing
          </p>
        </div>
      </section>
      <Footer />
    </main>
  );
}
